import React from 'react';
import {
  ProductsContainer,
  ProductWrapper,
  ProductsHeading,
  ProductTitle,
  ProductCard,
  ProductImg,
  ProductInfo,
  ProductDesc,
  ProductButton,
} from './ProductsElements';


const Products = ({ heading, data }) => {
  const handleAddToCart = (productName, productImg) => {
    const message = `Halo, saya tertarik dengan kue ini dan ingin pesan${productName}. Mohon info lebih lanjut. Berikut gambar produknya: https://razqacake.vercel.app${productImg}`;
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/6289602956136?text=${encodedMessage}`;

    window.open(whatsappUrl, '_blank');
  };

  return (
    <ProductsContainer>
      <ProductsHeading>{heading}</ProductsHeading>
      <ProductWrapper>
        {data.map((product, index) => {
          return (
            <ProductCard key={index}>
              <ProductImg src={product.img} alt={product.alt} />
              <ProductInfo>
                <ProductButton onClick={() => handleAddToCart( product.img)}>
                  {product.button}
                </ProductButton>
              </ProductInfo>
            </ProductCard>
          );
        })}
      </ProductWrapper>
    </ProductsContainer>
  );
};

export default Products;
